import Dialog from "components/dialog";
import Button from "components/button";
import Avatar from "components/avatar";
import { EmptyState } from "components/states";

const AssignStaffDialog = ({ isOpen, itemName, staffMembers, onAssign, onClose }) => (
  <Dialog
    isOpen={isOpen}
    onClose={onClose}
    title="Assign Action Item"
    description={itemName ? `Choose a staff member to follow up with ${itemName}.` : undefined}
    footer={
      <Button variant="secondary" onClick={onClose}>
        Cancel
      </Button>
    }
  >
    {staffMembers.length === 0 ? (
      <EmptyState variant="inline" title="No staff members found." />
    ) : (
      <ul className="flex flex-col gap-2">
        {staffMembers.map((staff, index) => (
          <li key={staff.id || `staff-${index}`}>
            <button
              type="button"
              onClick={() => onAssign(staff.id)}
              className="focus-ring flex w-full items-center gap-3 rounded-control border border-line p-3 text-left transition-colors hover:bg-surface-subtle"
            >
              <Avatar user={staff} size="md" noBorder decorative />
              <span className="min-w-0">
                <span className="block font-medium text-fg">
                  {staff.firstName} {staff.lastName}
                </span>
                <span className="block text-sm capitalize text-fg-muted">{staff.role}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    )}
  </Dialog>
);

export default AssignStaffDialog;
